(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ScrollTrigger", [], factory);
	else if(typeof exports === 'object')
		exports["ScrollTrigger"] = factory();
	else
		root["ScrollTrigger"] = factory();
})(self, () => {
return 